module.exports = __webpack_public_path__ + "static/media/trainings_mind_body_fitness.7c8345a5.webp";